import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { styles as S } from '../styles';
import { useDialog } from '../useDialog';
import { IconX, IconChevronRight } from '../icons';
const ABSCHNITTE = [
    {
        titel: 'Überblick & Rollen',
        punkte: [
            { kopf: 'Vorstand/Admin', text: 'darf alles: Belegungen anlegen, bearbeiten, freigeben, Plätze/Teams/Saisons/Schließtage verwalten und Einstellungen ändern.' },
            { kopf: 'Trainer', text: 'kann für die eigenen Mannschaften Belegungen anfragen; der Vorstand gibt sie frei. Trainer sind WordPress-Nutzer, die einem Team zugeordnet sind.' },
            { text: 'Der Plan zeigt immer eine Woche. Mit den Pfeilen oben blätterst du, „Heute" springt zur aktuellen Woche.' },
        ],
    },
    {
        titel: 'Ansichten wechseln',
        punkte: [
            { kopf: 'Woche', text: 'alle Plätze zusammen, überlappende Termine nebeneinander – der beste Gesamtüberblick.' },
            { kopf: 'Pro Platz', text: 'je Platz ein eigenes Raster. Nur hier kannst du Termine per Maus verschieben.' },
            { kopf: 'Liste', text: 'kompakte, chronologische Auflistung der Woche.' },
            { text: 'Mit den farbigen Chips oben blendest du einzelne Plätze ein/aus („Alle" / „Keine").' },
        ],
    },
    {
        titel: 'Belegung anlegen & bearbeiten',
        punkte: [
            { kopf: 'Anlegen', text: 'Button „Belegung" (bzw. „Anfragen") oben rechts. Platz, Mannschaft, Art, Wochentag und Uhrzeit wählen.' },
            { kopf: 'Wiederkehrend', text: 'für regelmäßiges Training. Die Saison-Spanne wird aus der aktiven Saison vorbelegt.' },
            { kopf: 'Bearbeiten', text: 'einen Termin im Plan anklicken. Konflikte (Doppelbelegung, Sperre, außerhalb der Öffnungszeit) werden gemeldet und lassen sich mit „Trotzdem speichern" übergehen.' },
        ],
    },
    {
        titel: 'Serien & einzelne Ausnahmen',
        punkte: [
            { text: 'Beim Anklicken eines Serien-Termins kannst du oben zwischen „ganze Serie" und „nur dieser Termin" umschalten.' },
            { kopf: 'Fällt aus', text: 'lässt einen einzelnen Termin entfallen (durchgestrichen), ohne die Serie zu ändern.' },
            { kopf: 'Nur diesen Termin speichern', text: 'verschiebt/ändert ausschließlich dieses eine Vorkommen (Ausnahme).' },
        ],
    },
    {
        titel: 'Verschieben per Drag-and-drop',
        punkte: [
            { text: 'In der Ansicht „Pro Platz" einen Termin mit der Maus auf einen anderen Tag/eine andere Uhrzeit ziehen (15-Minuten-Raster, Dauer bleibt).' },
            { text: 'Den unteren Rand ziehen ändert die Dauer.' },
            { text: 'Ist das Ziel belegt/gesperrt/geschlossen, springt der Termin zurück – Feinkorrektur dann per Klick im Fenster.' },
        ],
    },
    {
        titel: 'Filter, Suche & Kategorien',
        punkte: [
            { text: 'Die Filterleiste durchsucht Mannschaft/Platz/Titel und filtert nach Mannschaft und Art.' },
            { kopf: 'Nur meine', text: 'zeigt (für Trainer) nur die eigenen Mannschaften.' },
            { kopf: 'Kategorien', text: 'sind mehrere Ressourcen-Arten vorhanden (Platz, Raum, Gerät …), erscheint ein Kategorie-Filter.' },
            { text: '„Zurücksetzen" hebt alle Filter auf.' },
        ],
    },
    {
        titel: 'Ressourcen & Öffnungszeiten',
        nurVorstand: true,
        punkte: [
            { kopf: 'Ressourcen', text: 'Button „Ressourcen": Plätze, Felder, Räume oder Geräte anlegen – mit Name, Kategorie, Farbe und optionaler Öffnungszeit.' },
            { text: 'Außerhalb der Öffnungszeit liegende Belegungen werden gewarnt; geschlossene Stunden sind im Raster abgedunkelt.' },
        ],
    },
    {
        titel: 'Teams & Trainer',
        nurVorstand: true,
        punkte: [
            { kopf: 'Teams', text: 'Button „Teams": Mannschaften anlegen/bearbeiten und WordPress-Nutzer als Trainer zuordnen.' },
            { text: 'Mannschaften lassen sich zusätzlich aus einer .ics-Datei importieren (auf der Modulseite oben).' },
            { text: 'Die Trainer-Zuordnung ist die Grundlage für „Meine", den Freigabe-Workflow und die E-Mails.' },
        ],
    },
    {
        titel: 'Freigabe-Workflow (Anfragen)',
        punkte: [
            { kopf: 'Trainer', text: 'legt eine Anfrage an (Status „Angefragt", gelb gestrichelt) – nur für eigene Mannschaften.' },
            { kopf: 'Vorstand', text: 'sieht oben „Offene Anfragen (n)", öffnet die Anfrage und wählt „Freigeben" oder „Ablehnen".' },
            { text: 'Freigegebene Termine erscheinen normal, abgelehnte verschwinden aus dem Plan.' },
        ],
    },
    {
        titel: 'E-Mail-Benachrichtigungen',
        nurVorstand: true,
        punkte: [
            { text: 'Neue Anfrage → E-Mail an den Vorstand; Freigabe/Ablehnung → E-Mail an den anfragenden Trainer.' },
            { text: 'Unter „Einstellungen" aktivierbar; optional eine feste Vorstands-Adresse hinterlegen (sonst alle Nutzer mit Verwaltungsrecht).' },
        ],
    },
    {
        titel: 'Sperren (Wartung/Belegung)',
        nurVorstand: true,
        punkte: [
            { kopf: 'Sperren', text: 'Button „Sperren": einen Platz ganz- oder stundenweise blockieren (z. B. Pflege, Fremdnutzung) – einmalig oder wiederkehrend.' },
            { text: 'Gesperrte Zeiten erscheinen schraffiert; eine Belegung dort wird gewarnt.' },
        ],
    },
    {
        titel: 'Schließtage & Feiertage',
        nurVorstand: true,
        punkte: [
            { kopf: 'Schließtage', text: 'Button „Schließtage": volltägige, platzübergreifende Schließungen – Einzeltag, Zeitraum (Ferien) oder jährlich.' },
            { text: 'An Schließtagen entfallen Termine automatisch – im Plan, im PDF und im Kalender-Abo.' },
            { text: 'Mit „Feiertage importieren" lassen sich die gesetzlichen Feiertage Baden-Württembergs für ein Jahr übernehmen.' },
        ],
    },
    {
        titel: 'Saisons',
        nurVorstand: true,
        punkte: [
            { text: 'Unter „Einstellungen → Saisons" mehrere benannte Zeiträume anlegen (z. B. „Sommer 2026", „Halle 2026/27").' },
            { text: 'Die als aktiv markierte Saison wird bei neuen Serien vorbelegt. „Zu Saison springen" oben navigiert zur Startwoche.' },
        ],
    },
    {
        titel: 'Statistik',
        punkte: [
            { text: 'Button „Statistik": Auslastung je Platz, Stunden je Mannschaft und Verteilung nach Art – jeweils für die angezeigte Woche.' },
        ],
    },
    {
        titel: 'PDF-Export',
        punkte: [
            { text: 'Button „PDF": die aktuelle Woche (oder mehrere Wochen) als druckbares PDF, optional auf bestimmte Plätze gefiltert.' },
            { text: 'Ohne installiertes Dompdf öffnet sich eine druckbare HTML-Ansicht.' },
        ],
    },
    {
        titel: 'Kalender-Abo (iCal)',
        nurVorstand: true,
        punkte: [
            { text: 'Unter „Einstellungen → Kalender-Abo" den Link kopieren und in Google/Apple/Outlook als Kalender-Abo eintragen.' },
            { text: 'Der Feed hält sich automatisch aktuell und zeigt nur bestätigte Termine. Mit „&platz=ID" oder „&team=ID" filterbar.' },
            { text: '„Link erneuern" macht alte Abos ungültig.' },
        ],
    },
    {
        titel: 'Einstellungen: Erscheinungsbild',
        nurVorstand: true,
        punkte: [
            { kopf: 'Akzentfarbe', text: 'unter „Einstellungen → Erscheinungsbild" wählbar – färbt Kopfzeile, Schaltflächen und Hervorhebungen.' },
            { text: 'Im öffentlichen Plan (Shortcode [platzbelegung]) übernimmt die Anzeige die Schrift deines Themes.' },
        ],
    },
];
export function HilfePanel({ onClose, version }) {
    const dialogRef = useDialog(onClose);
    const [offen, setOffen] = useState(() => new Set([0]));
    const toggle = (i) => setOffen((s) => {
        const next = new Set(s);
        next.has(i) ? next.delete(i) : next.add(i);
        return next;
    });
    const alleAuf = () => setOffen(new Set(ABSCHNITTE.map((_, i) => i)));
    const alleZu = () => setOffen(new Set());
    return (_jsx("div", { style: S.overlay, onClick: onClose, children: _jsxs("div", { ref: dialogRef, role: "dialog", "aria-modal": true, "aria-label": "Hilfe", style: { ...S.modal, maxWidth: 640 }, onClick: (e) => e.stopPropagation(), children: [_jsxs("div", { style: S.modalHead, children: [_jsx("h3", { style: S.modalTitel, children: "Hilfe & Bedienung" }), _jsx("button", { style: S.iconBtn, onClick: onClose, "aria-label": "Schlie\u00DFen", children: _jsx(IconX, { size: 18 }) })] }), _jsxs("div", { style: S.modalBody, children: [_jsxs("div", { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }, children: [_jsx("p", { style: { margin: 0, fontSize: 13, color: '#5a6258' }, children: "Klicke einen Punkt an, um die Anleitung aufzuklappen." }), _jsxs("div", { style: { display: 'flex', gap: 4, flexShrink: 0 }, children: [_jsx("button", { style: S.chipMini, onClick: alleAuf, children: "Alle auf" }), _jsx("button", { style: S.chipMini, onClick: alleZu, children: "Alle zu" })] })] }), _jsx("div", { style: { marginTop: 8 }, children: ABSCHNITTE.map((a, i) => {
                                const auf = offen.has(i);
                                return (_jsxs("div", { style: S.hilfeItem, children: [_jsxs("button", { style: S.hilfeKopf, "aria-expanded": auf, onClick: () => toggle(i), children: [_jsx("span", { style: { transform: auf ? 'rotate(90deg)' : 'none', transition: 'transform .15s', display: 'inline-flex' }, children: _jsx(IconChevronRight, { size: 16 }) }), _jsx("span", { style: { flex: 1 }, children: a.titel }), a.nurVorstand && _jsx("span", { style: S.hilfeBadge, children: "Vorstand" })] }), auf && (_jsx("ul", { style: S.hilfeListe, children: a.punkte.map((p, j) => (_jsxs("li", { style: S.hilfePunkt, children: [p.kopf && _jsxs("strong", { children: [p.kopf, ": "] }), p.text] }, j))) }))] }, i));
                            }) }), _jsxs("p", { style: { marginTop: 16, fontSize: 12, color: '#9aa097', textAlign: 'center' }, children: ["Platzbelegung \u2013 \u201EDigitales Vereinsheim\"", version ? ` · Version ${version}` : '', _jsx("br", {}), "\u00A9 ", new Date().getFullYear(), " Stefan Pr\u00F6ll \u00B7 MIT-Lizenz"] })] }), _jsx("div", { style: S.modalFoot, children: _jsx("button", { style: S.primaryBtn, onClick: onClose, children: "Schlie\u00DFen" }) })] }) }));
}
